import { ReactNode } from 'react'

type Props = {
  label: string
  value: number | string
  icon: ReactNode
  iconBgClass: string
  iconColorClass?: string
}

export default function StatCard({
  label,
  value,
  icon,
  iconBgClass,
  iconColorClass = 'text-ink',
}: Props) {
  return (
    <div className="flex items-center gap-1 rounded-xl bg-white px-5 py-4 shadow-[0px_1px_3px_0px_rgba(0,0,0,0.1),0px_1px_2px_0px_rgba(0,0,0,0.06)]">
      <div className="flex min-w-0 flex-1 flex-col gap-1">
        <p className="font-display text-sm text-gray-500">{label}</p>
        <p className="font-display text-3xl font-semibold text-gray-900">{value}</p>
      </div>
      <div
        className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-xl ${iconBgClass} ${iconColorClass}`}
      >
        {icon}
      </div>
    </div>
  )
}
